// extracted by mini-css-extract-plugin
module.exports = {"container":"TravelersUgcSectionTitle_container__jSS1j","title":"TravelersUgcSectionTitle_title__no4SR"};